module.exports = __webpack_public_path__ + "media/images/icons/printer-08be21f63c4b64bee29bbcdb8c195c36.svg";